/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemChatActivity_EmbedChatActivity = {
    readonly _id: string;
    readonly patient: {
        readonly _id: string;
        readonly firstname: string | null;
        readonly lastname: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_EmbedNode" | "TypographyChatActivityLastMessage_EmbedChatActivity" | "TypographyChatActivityUpdatedAt_EmbedChatActivity" | "AvatarChatActivityReassign_EmbedChatActivity">;
    readonly " $refType": "ListItemChatActivity_EmbedChatActivity";
};
export type ListItemChatActivity_EmbedChatActivity$data = ListItemChatActivity_EmbedChatActivity;
export type ListItemChatActivity_EmbedChatActivity$key = {
    readonly " $data"?: ListItemChatActivity_EmbedChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemChatActivity_EmbedChatActivity">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeAssignee"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemChatActivity_EmbedChatActivity",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastname",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_EmbedNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyChatActivityLastMessage_EmbedChatActivity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyChatActivityUpdatedAt_EmbedChatActivity"
    },
    {
      "condition": "includeAssignee",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarChatActivityReassign_EmbedChatActivity"
        }
      ]
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
})();
(node as any).hash = 'bb859dc38a34104b60f5e3d2e6bdad1e';
export default node;
